import React from 'react'
import styled from 'styled-components'
import 'react-phone-number-input/style.css'

interface IInputWrapper {
  width?: boolean
  nomarg?: boolean
  w?: string
  value?: boolean
  invalid?: boolean
  disabled?: boolean
  m?: string
  minHeight?: boolean
  maxHeight?: boolean
  height?: string
  children: React.ReactNode
  blured: boolean
  end?: boolean
  noPadding?: boolean
}

export const InputWrapper = styled.div<Pick<IInputWrapper, any>>`
  position: relative;
  width: ${(props) => (props.width ? props.width : '100%')};

  ${props => props.end && 'display:flex;justify-content:flex-end;'}
  input, textarea{
   -moz-appearance: textfield;

    margin: 0.2rem 0;
    width: 100%;
    height: ${(props) => props.height || '40px'};
    border-radius: 12px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400; 
    border:1px solid ${props => (!props.invalid && props.value) ? props.theme.colorDividerLight : (props.invalid && props.blured) ? '#E74C3C' : props.theme.colorDividerDefault};
    background-color: ${props => props.theme.colorSurface1};
    outline:none;
    color:white;
    padding-left: 1rem;
    transition: .2s ease;

    &::placeholder {
      color:  ${props => props.theme.textColorFaded}; 
      font-size: 16px; 
      line-height: 20px;
      font-weight: 400; 
      opacity: 1; /* Firefox applies a lower opacity by default, so set this to 1 for consistency */
    }

    &:hover{
      border:1px solid ${props => props.theme.colorDividerLight};
    }

    
  }
  textarea{
    padding-top: 5px;
  }


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input:focus, textarea:focus {
  border: 1px solid #ff9900 !important;
}

  input[type='color']{
    border: none;
    padding: 0;
    overflow: hidden;
    cursor: pointer;

  }

input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
    border-radius: 0;

}

input[type="color"]::-webkit-color-swatch {
    border: none;
    border-radius: 0;

}

input[type="color"]::-moz-color-swatch {
    border: none;
    border-radius: 0;
}

`

interface ISelectContainer {
  invalid?: string
}

export const SelectContainer = styled.div<ISelectContainer>`
  width: 100%;
  color: ${(props) => props.theme.colorGray};
  outline: none;
  height: 2.5rem;
  border: 1px solid ${(props) => (props.invalid ? 'crimson' : '#c3c0cc')};
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
`

interface ISelectWrapper {
  width?: string
  nomarg?: boolean
  m?: string
  labelText?: string
  min?: boolean
  invalid?: string
  view?: boolean
}

export const SelectWrapper = styled.div<ISelectWrapper>`
  width: 100%;
  width: ${(props) => props.width} !important;
  margin: ${(props) => props.m};
  ${(props) => props.min && 'min-width:200px;'}
  ${(props) => props.view && 'user-select:none; pointer-events:none;'}
  position: relative;

  select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 0 1em;
  }

`
interface ILabel {
  labelText?: string
  children: React.ReactNode
}

export const Label = ({ labelText, nomarg }: Pick<ILabel, any>) => {
  return (
    <LabelWrapper labelText={labelText} nomarg={nomarg}>
      {labelText}
    </LabelWrapper>
  )
}

interface ILabelWrapper {
  w?: string
  labelText?: string
  htmlFor?: string
  nomarg?: boolean
}

export const LabelWrapper = styled.label<ILabelWrapper>`
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => props.theme.textColor};
  width: ${(props) => props.w};

`

interface ICollapsableAbsolute {
  expanded?: any
  right?: boolean
  height?: boolean
}

export const CollapsableAbsolute = styled.div<ICollapsableAbsolute>`
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  max-height: ${(props) => (props.expanded ? `${props.height}` : '0')};
  transition: all 500ms;
  margin-bottom: ${(props) => (props.expanded ? '1.25rem' : '0')};
  /* position: absolute;
  ${(props) => (props.right ? 'right: 0;' : 'left: 0;')} */
  position: absolute;
  top: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`

export const DateInputWrapper = styled.div`
  position: relative;
  * {
    margin: 0;
    padding: 0;
    user-select: none;
  }

  .calendar {
    user-select: none;
    max-width: 20rem;
    display: flex;
    height: fit-content;
    margin: 0 auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 5%;
    left: 20%;
    border-radius: 8px;
    padding: 0.3rem;
    background: ${props => props.theme.inputActiveBackground};
    border:${props => props.theme.inputBorder};
  }

  .day {
    position: relative;
    width: calc(100% / 7);
    height: 44px;
    display: inline-block;
    background-color: transparent;
    padding: 0;
    font-size: 0.8rem;
    width: 44px;
    margin: 0;
    box-sizing: border-box;
    z-index: 1;
    text-align: center;
  }
  .days {
    width: 40rem;
    position: relative;
    display: flex;
    width: calc(100% / 7);
    height: 44px;
    gap: 1.6rem;
    align-items: center;
    justify-content: center;
  }
  .name-day {
    width: 44px;
    border-bottom: 1px solid gainsboro;
    padding: 0.7rem;
    font-size: 0.75rem;
  }
  .selected {
    color: ${(props) => props.theme.colorWhite};
    background-color: ${(props) => props.theme.colorOrange};
  }
  .before {
    /* ds */
  }
  .disabled {
    background-color: #c3c0cc80;
    cursor: not-allowed;
    color: white;
  }
  .today {
    /* border: 1px solid black; */
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid gainsboro;

    padding: 0.8rem;
    display: flex;
    width: 90%;
    justify-content: space-between;
    align-items: center;
  }
  .header p {
    font-size: 1.2rem;
    color: white;
    text-align: center;
    cursor: pointer;
    width: 90%;
    color: ${(props) => props.theme.colorGray};
  }
  .arrow {
    font-size: 1.5rem;
    cursor: pointer;
  }
  .numbers-container {
    width: 100%;
    border: none;
  }
  .single-day {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .single-day:hover {
    background-color: ${(props) => props.theme.colorOrange};
    color: ${(props) => props.theme.colorWhite};
    cursor: pointer;
  }
  .disabled:hover {
    cursor: not-allowed;
    background-color: #c3c0cc;
  }
`

interface IDateInputPlaceholder {
  filled?: any
  open?: boolean
  invalid?: string
  blured?: string
}

export const DateInputPlaceholder = styled.div<IDateInputPlaceholder>`
  width: 100%;
  background: ${(props) => (props.filled ? props.theme.inputActiveBackground : 'none')};
  border: ${(props) => (props.filled ? '' : props.theme.inputBorder)};
  box-shadow: ${(props) => (props.filled ? `${props.theme.shadowInputActive}` : '')};
  height: 2.5rem;
  padding: 0 1rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  transition: all 0.5s;
  font-size: 0.87rem;
  cursor: ${(props) => (props.open ? 'not-allowed' : 'default')};
  ${(props) => props.blured && props.invalid && 'border: 1px solid red;'}
  background-color:red;
`

export const LoginPasswordField = styled.div`
  display: flex;
  justify-content: space-between;
  gap:1rem;

input{
  aspect-ratio: 1/1;
  border-radius: 10px;
  border:1px solid #c3c0cc;
  text-align: center;
  font-size: 1.2rem;
  padding: 0;
   -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


`

export const SwitchContainer = styled.div`

  width: 26px;
  height: 13px;
  border-radius: 20px;
  background-color: ${props => props.theme.inputActiveBackground};
  padding: 1px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin: 10px 0;
  border: ${props => props.theme.inputBorder};

`

export const InputIcon = styled.div<{ left?: boolean }>`
 
  position: absolute;
  ${props => props.left ? 'left:1rem;' : 'right:1rem;'}
  top:50%;
  transform: translateY(-50%);
  display: grid;
  place-items: center;

`